<template>
  <div class="media">
    <div :class="compCssClasses" class="media-inner media-left">
      <slot name="left"></slot>
    </div>

    <div :class="compCssClasses" class="media-inner media-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import { propsStringEnumValidator } from '@/libs/utils'

const xValidator = propsStringEnumValidator(['l', 'c', 'r'])
const yValidator = propsStringEnumValidator(['t', 'c', 'b'])

export default {
  name: 'VMedia',
  data() {
    return {
      classesMap: {
        x: {
          l: 'x-left',
          r: 'x-right',
          c: 'x-center',
        },
        y: {
          t: 'y-top',
          c: 'y-center',
          b: 'y-bottom',
        },
      },
    }
  },

  props: {
    xAlign: {
      type: String,
      default: 'c',
      validator: xValidator,
    },
    yAlign: {
      type: String,
      default: 'c',
      validator: yValidator,
    },
    halfFilling: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    compCssClasses: function() {
      const arr = [
        this.classesMap.x[this.xAlign],
        this.classesMap.y[this.yAlign],
        { half: this.halfFilling },
      ]

      return arr
    },
  },
}
</script>

<style scoped lang="scss">
.media {
  width: 100%;
  display: flex;
  flex-direction: row;

  &-inner {
    display: flex;
    position: relative;
  }

  .half {
    width: 50%;
  }
}

.x-left {
  justify-content: flex-start;
}
.x-right {
  justify-content: flex-end;
}
.x-center {
  justify-content: center;
}

.y-top {
  align-items: flex-start;
}
.y-center {
  align-items: center;
}
.y-bottom {
  align-items: flex-end;
}
</style>
